// userStore.js
import { writable } from 'svelte/store';

// Creamos los stores para almacenar los datos del usuario y los posibles errores
export const user = writable(null);
export const errors = writable(null);

// URL base y parámetros de consulta para obtener la información del usuario
const urlBase = "https://api.rastros.cl/api/users/me";
const queryParams = new URLSearchParams({
  'populate[0]': 'new_profile',
  'populate[1]': 'new_profile.new_company',
  'populate[2]': 'new_profile.new_company.new_trucks',
  'populate[3]': 'new_profile.new_company.new_trucks.new_tanks',
  'populate[4]': 'new_profile.new_company.new_trucks.new_tanks.new_devices',
  'populate[5]': 'role',
  'populate[6]': 'new_profile.avatar',
  'populate[7]': 'new_profile.new_company.new_trips',
  'populate[8]': 'new_profile.new_company.new_trips.origen',
  'populate[9]': 'new_profile.new_company.new_trips.routes',
  'populate[10]': 'new_profile.new_company.new_trips.order',
  'populate[11]': 'new_profile.new_company.new_trips.order.new_order_details'
});

// Función que realiza la petición fetch para obtener los datos del usuario
export async function callUser(jwt) {
 
  // Preparamos el header con la autorización usando el token JWT
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${jwt}`);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  try {
    console.log(`callUser: JWT received: ${jwt ? 'Yes' : 'No'}`);
    const fullUrl = `${urlBase}?${queryParams.toString()}`;
    console.log(`callUser: Fetching user data from: ${fullUrl}`);
    const response = await fetch(fullUrl, requestOptions);
    
    // Si la respuesta no es correcta, se setea en el store de errores
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`callUser: API response not OK. Status: ${response.status}, Error: ${errorText}`);
      errors.set(errorText);
      return;
    }
    
    // Parseamos la respuesta JSON y actualizamos el store 'user'
    const result = await response.json();
    // Si la estructura es {data: { ... }}
    console.log("callUser: User data fetched successfully:", result);
    user.set(result);

  } catch (err) {
    console.error("callUser: Error fetching user data:", err);
    errors.set(err);
  }
}
